<template>
    <v-autocomplete
    v-model="localSelectedID"
    :items="definitions"
    :search-input.sync="search"
    :filter="customFilter"
    item-text="name"
    item-value="id"
    placeholder="Search items"
    hide-details
    class="crx-input pt-0 crx-input-override"
    spellcheck="false"
    :clearable="clearable">

    <template
    slot="selectionn"
    slot-scope="{ item }">
      <div style="display: flex;flex-wrap:nowrap;align-items:center;">
        <v-list-tile-avatar
        size="30px"
        color="red lighten-2"
        class="headline font-weight-light white--text">
          {{ item.name.charAt(0) }}
        </v-list-tile-avatar>
        <span class="blue-grey--text">
          {{ item.name }}
        </span>
      </div>
    </template>

    <template 
    slot="no-data">
      <v-list-tile>
        <v-list-tile-title>
          No matching
          <strong>definitions</strong>
        </v-list-tile-title>
      </v-list-tile>
    </template>

    <template
    slot="item"
    slot-scope="{ item }">

    <v-list-tile-avatar
    color="red lighten-2"
    class="headline font-weight-light white--text">
      {{ item.name.charAt(0) }}
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title v-html="highlight(item.name)"></v-list-tile-title>
      <v-list-tile-sub-title v-text="item.symbol"></v-list-tile-sub-title>
    </v-list-tile-content>

    </template>

    </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    selectedID: null,
    clearable: false
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapState({
      definitions: state => Object.values(state.db.inventoryDefinitions.definitions)
    }),
    keywords () {
      return (this.search || '').toLowerCase().split(' ')
    },
    localSelectedID: {
      get () {
        return this.selectedID
      },
      set (nv) {
        this.$emit('update:selectedID', nv)
      }
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      return this.keywords.every(keyword => {
        return (item.name + item.description).toLowerCase().indexOf(keyword) > -1
      })
    },
    highlight (str) {
      var replacedStr = (this.search || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      return str.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-bold">$&</span>')
    }
  }
}
</script>

